import Blue from "~/core";
import { retach, toggle as Toggle } from "../plugins";
import { addEvents, screen } from "../utils";

new Blue({
  name: "Footer",
  selector: ".footer",
  setup(footer) {
    const navItems = [...footer.querySelectorAll(".footer__column")];
    const media = screen.md_dn;

    navItems.forEach((item) => {
      const container = item;
      const trigger = item.querySelector(".footer__nav-toggle");
      const content = item.querySelector(".footer__nav-menu");
      const props = ["height", "visibility", "opacity"];

      if (!content || !trigger) return;
      new Toggle({
        media,
        container,
        trigger,
        content,
        props
	 });
    
    });
  },
});
